import moment, { Moment } from 'moment';
import { Cloneable } from '../Utils/Cloneable';
import { MarketDateFilter, RawIndexData, IndexData } from 'models/types';
import { getBackfilledIndexData, getDateSortedIndexData, filterDataByMarketDateFilter } from 'utils/index';

export enum CompositeIndexType {
	EDITION_INDEX = 'EDITION_INDEX'
}

export const CompositeIndexDisplayName: Record<CompositeIndexType, string> = {
	[CompositeIndexType.EDITION_INDEX]: 'Editions Index'
};

export interface RawCompositeIndex {
	id: string;
    name: string;
	type: string;
	index_data: RawIndexData[];
	recalculate: boolean;
	last_calculation_date: string;
}

export class CompositeIndexModel extends Cloneable {
	id: string;
	name: string;
	type: string;
	indexData: IndexData[];
	backfilledData: IndexData[];
	recalculate: boolean;
	lastCalculationDate: Moment | null;

	constructor(artistIndexData?: RawCompositeIndex) {
		super();
		this.id = artistIndexData?.id || '';
		this.name = artistIndexData?.name || '';
		this.type = artistIndexData?.type || '';
		this.indexData = (artistIndexData?.index_data || [])
			.map((rawPriceData: RawIndexData): IndexData => {
				return {
					index: rawPriceData.index,
					date: moment(rawPriceData.date),
					arp: rawPriceData.arp,
					normalizedArp: rawPriceData.normalized_arp,
					weightedIndex: rawPriceData.weighted_index
				}
			});
		this.backfilledData = getBackfilledIndexData(this.indexData);
		this.recalculate = !!artistIndexData?.recalculate;
		this.lastCalculationDate = artistIndexData?.last_calculation_date ? moment(artistIndexData.last_calculation_date) : null;
	}

	public getPriceData(): IndexData[] {
		return this.indexData || [];
	}

	public getDateSortedIndexData(): IndexData[] {
		return getDateSortedIndexData(this.indexData);
	}

	public getMostRecentIndexData(): IndexData | null {
		if (this.indexData.length) {
			return this.indexData[0];
		} else {
			return null;
		}
	}

	public getSecondMostRecentIndexData(): IndexData | null {
		if (this.indexData.length > 1) {
			return this.indexData[1];
		} else {
			return null;
		}
	}

	public getIndexDataUniqueYears(): number[] {
		const years = this.indexData.map(indexData => indexData.date ? indexData.date.year() : null)
									.filter(year => year !== null);
		return Array.from(new Set(years)) as number[];
	}

	public filterDataByMarketDateFilter = (range: MarketDateFilter, useBackfilledData?: boolean) => {
		return filterDataByMarketDateFilter(range, useBackfilledData ? this.backfilledData : this.indexData);
	};	
}
